export default __webpack_public_path__ + "static/media/IMG_9242.df48add5.gif";